<template>
	<div class="form-component">
		<loading-component v-if="submitting"></loading-component>
		<form ref="form" v-on:submit.prevent="validateBeforeSubmit" v-if="!formSubmitted" class="form">
			<input name="action" type="hidden" :value="apiUrl">
			<input name="locale" type="hidden" :value="locale">
			<input name="entryId" type="hidden" :value="entryId">

			<div class="ajax-error" 
				v-show="showAjaxError" 
				v-html="'<div class=contact-error>'+ajaxErrorText+'</div>' + '<div class=coming-soon-error>'+comingSoonErrorText+'</div>'">
			</div>

			<div class="form-groups">
				<div v-for="input in formInputs"
					 :key="input.name"
					 class="form-group"
					 :class="{'has-error': errors.has(input.name), 'two-col': input.component === 'textarea'}"
				>
					<select v-if="input.component === 'dropdown'"
							:name="input.name"
							v-model="form[input.name]"
							v-validate="validation(input)"
							v-bind:disabled="isDisabled(input)"
							@change="onChange(input)">
						<option value="" disabled hidden>{{ input.label }}</option>
						<template v-if="input.optgroup">
							<optgroup :label="group.title" v-for="group in input.options">
								<option v-for="n in group.options" 
										:value="n.value" 
										v-if="!n.projectArchived && getRegisterParam">
									{{ n.text }}
								</option>
								<option v-for="n in group.options" 
										:value="n.value"
										v-if="!getRegisterParam">
									{{ n.text }}
								</option>
							</optgroup>
						</template>
						<template v-else>
							<option v-for="n in input.options" :value="n.value">
								{{ n.text }}
							</option>
						</template>
					</select>

					<textarea v-if="input.component === 'textarea'" :name="input.name" v-model="form[input.name]"
							  v-validate="validation(input)" v-bind:disabled="isDisabled(input)"
							  class="form-control" :placeholder="input.label">
					</textarea>

					<input 	v-if="input.component === 'textbox' && input.type === 'email'" :name="input.name" v-model="form[input.name]"
							  v-validate="validation(input)" v-bind:disabled="isDisabled(input)"
							  type="email" :placeholder="input.label">

					<input 	v-if="input.component === 'textbox' && input.type !== 'email'" :name="input.name" v-model="form[input.name]"
							  v-validate="validation(input)" v-bind:disabled="isDisabled(input)"
							  type="text" :placeholder="input.label">

					<div v-if="input.component === 'checkbox'">
						<input :name="input.name" :id="input.name" type="checkbox" v-model="form[input.name]"
							   v-validate="validation(input)" v-bind:disabled="isDisabled(input)"
							   value="1">
						<label :for="input.name">{{ input.label }}</label>
					</div>

					<span v-if="input.type === 'phone'" class="error-message">{{ phoneErrorMessage }}</span>
					<span v-else class="error-message">{{ fieldErrorMessage }}</span>
				</div>
			</div>

			<div class="honeypot"><input type="text" name="catName" value="" tabindex="-1"></div>

			<div class="submit-wrapper">
				<button class="btn" type="submit">{{ submitText }}</button>
			</div>
		</form>
		
		<div v-else class="success-message" 
			v-html="'<div class=contact-success>'+successMessage+'</div>' + '<div class=coming-soon-success>'+comingSoonSuccessMessage+'</div>'">
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import LoadingComponent from './Loading.vue';
	import _ from 'lodash';
	import helpers from '../helpers';

	export default {
		components: {
			LoadingComponent
		},

		data() {
			return {
				getRegisterParam: false,
				formSubmitted: false,
				submitting: false,
				showAjaxError: false,
				formInputs: [],
				form: []
			}
		},

		props: [
			'apiUrl',
			'entryId',
			'locale',
			'inputs',
			'successMessage',
			'ajaxErrorText',
			'comingSoonSuccessMessage',
			'comingSoonErrorText',
			'submitText',
			'fieldErrorMessage',
			'phoneErrorMessage'
		],

		created() {
			this.getRegisterParam = helpers.getURLParameter("register") === "true";

			let projectTypeId = helpers.getURLParameter("projectTypeId");
			let projectId = helpers.getURLParameter("projectId");

			this.formInputs = this.inputs;

			_.each(this.formInputs, (value, index) => {
				Vue.set(this.form, value.name, "");
			});

			if (projectTypeId) {
				this.form["projectType"] = projectTypeId;
				this.onChange(this.formInputs.projectType);
			}
			if (projectId) {
				this.form["project"] = projectId;
			}
		},

		methods: {
			validateBeforeSubmit(e) {
				this.$validator.validateAll();
				if (!this.errors.any()) {
					this.submitForm()
				}
			},
			submitForm() {
				this.submitting = true;

				var options = new FormData(this.$refs["form"]);

				var url = '/';
				if (this.getRegisterParam) {
					url += '?register=true';
				}

				this.$http.post(url, options).then(response => {

					this.submitting = false;

					var data = response.body;
					if (data.success) {
						this.showAjaxError = false;
						this.formSubmitted = true;
					}
					else {
						console.log(data.errors);
						this.showAjaxError = true;
						this.formSubmitted = false;
					}

				}, response => {
					this.submitting = false;
					this.showAjaxError = true;
					this.formSubmitted = false;
				});
			},
			validation(input) {
				var validator = input.validator ? input.validator : { rules: {} };
				if (input["requiredIf"]) {
					validator.rules = { required: this.form[input["requiredIf"]] !== '' };
				}
				if (input["requiredIfNot"]) {
					validator.rules = { required: this.form[input["requiredIfNot"]] === '' };
				}
				if (input["phoneValidation"]) {
					validator.rules = { 
						required: true,
						regex: /(?:\d{1}\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/ 
					};
				}
				if (input["phoneValidationOptional"]) {
					validator.rules = { 
						required: false,
						regex: /(?:\d{1}\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/ 
					};
				}
				return validator;
			},
			isDisabled(input) {
				return input.options && input.options.length < 1;
			},
			onChange(input) {
				if (input.onChange == "onProjectTypeChange") {
					this.onProjectTypeChange();
				}
			},

			onProjectTypeChange() {
				this.inputs['project'].options = this.inputs['project'].datasource.filter((option) => {
					return option.id == this.form.projectType;
				});
			}
		}
	}
</script>
